
/**
 * @export
 * @enum {string}
 */
export enum SavedListType {
    COMPANY = 'COMPANY',
    DEBT = 'DEBT',
    FUND = 'FUND',
    INVESTOR = 'INVESTOR',
    LP = 'LP',
    PERSON = 'PERSON',
    PUBLIC_COMPANY = 'PUBLIC_COMPANY',
    SP = 'SP',
    SHARE_CLASS = 'SHARE_CLASS',
    MARKET_MAP = 'MARKET_MAP',
    DEAL = 'DEAL'
}